module.exports = __webpack_public_path__ + "static/media/06_salaredacao.3bb27a76.jpg";